import type { Component, TimeAnimationOptions } from '@wix/thunderbolt-becky-types'
import type { FeatureRefs } from '../cssFeatures.types'
import { createCssCompNode } from '../cssCompNode'
import type { VariantRelationViewItem } from '@wix/thunderbolt-catharsis'
import { envRefs } from '@wix/thunderbolt-catharsis'
import { toBreakpointVariantsMap } from '../../utils/toBreakpointVariantsMap'
import { toCompVariants } from '../../utils/toCompVariants'
import { isVariantRelation } from '../../utils/variantsUtils'

function getMobileVariation(
	values: Array<TimeAnimationOptions | VariantRelationViewItem<TimeAnimationOptions>>
): TimeAnimationOptions | null {
	for (const value of values) {
		if (isVariantRelation(value) && value.variants.find((variant) => variant.type === 'Mobile')) {
			return value.to
		}
	}

	return values[0] as TimeAnimationOptions
}

export const motionTimeAnimations = createCssCompNode('motionTimeAnimations', 'motionTimeAnimations', {
	getDependencies: (component: Component, refs: FeatureRefs<'motionTimeAnimations'>) =>
		component.effectsQuery && component.id !== 'MENU_AS_CONTAINER_EXPANDABLE_MENU'
			? {
				effectsData: refs.effectsQuery(component.effectsQuery),
				isMobileView: envRefs.isMobileView,
				showScreenInComp: envRefs.showScreenInComp,
				hasResponsiveLayout: refs.hasResponsiveLayout(component),
			}
			: null,

	toViewItem: (component, deps) => {
		if (!deps || deps.showScreenInComp) {
			return null
		}

		const { effectsData, isMobileView } = deps
		const effects = effectsData?.values

		if (!effects?.length) {
			return null
		}

		return effects
			.filter((effect) => effect.type === 'TimeAnimation')
			.map((effect) => ({
				variants: toCompVariants(effect.value.values),
				data: deps.hasResponsiveLayout
					? toBreakpointVariantsMap(
						effect.value.values as Array<
								TimeAnimationOptions | VariantRelationViewItem<TimeAnimationOptions>
						>,
						(x) => x
					)
					: {
						default: {
							'': isMobileView
								? getMobileVariation(
									effect.value.values as Array<
												TimeAnimationOptions | VariantRelationViewItem<TimeAnimationOptions>
									>
								)
								: (effect.value.values[0] as TimeAnimationOptions),
						},
					},
			}))
	},
})
